/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'ngx-app',
  templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit {
  currentLanguage= 'en';
  loading = true;
  constructor(private analytics: AnalyticsService, private seoService: SeoService,
    public translateService: TranslateService,
    private loaderService: LoaderService) {
      translateService.addLangs(['en', 'vi']);
      translateService.setDefaultLang('en');
      this.loaderService.isLoading.subscribe((value) => {
      this.loading = value;
    });
  }
  switchLanguage(lang: string)
  // tslint:disable-next-line: one-line
  {
    this.currentLanguage = lang;
    localStorage.setItem('lang',lang);
    this.translateService.use(this.currentLanguage);
  }
  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
}
